/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../../components/clearCach/clear";
import {
  X,
  Truck,
  Check,
  RefreshCw,
  Lock,
  Info,
  Package,
  MousePointer,
  MapPin,
  BarChart4,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ActivationTrackship({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer || []);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data, setData] = useStoreFormDraft(store);
  const { t } = useTranslation();

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, trackshipactive: !data.trackshipactive });
  };

  const handleDChange2 = () => {
    setData({ ...data, buttontrack: !data.buttontrack });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if TrackShip service is activated
    if (!data.trackshipactive) {
      await showAlert(
        "warning",
        t("servicePageActivation.trackship.alerts.notActivated.title"),
        t("servicePageActivation.trackship.alerts.notActivated.text")
      );
      return;
    }

    if (data.trackshipactive && !data.nametrack) {
      await showAlert(
        "warning",
        t("servicePageActivation.trackship.alerts.missingData.title"),
        t("servicePageActivation.trackship.alerts.missingData.text")
      );
      return;
    }

    try {
      setLoading(true);
      apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);

      await showAlert("success", t("servicePageActivation.trackship.alerts.success.title"));
      close();
    } catch (error) {
      setLoading(false);

      await showAlert(
        "error",
        t("servicePageActivation.trackship.alerts.error.title"),
        t("servicePageActivation.trackship.alerts.error.text")
      );

      console.error("Error saving TrackShip settings:", error);
    }
  };

  const handleDisable = async (e) => {
    e.preventDefault();

    // Vérifier si la plateforme est déjà désactivée
    if (!data.nametrack) {
      await Swal.fire({
        icon: "info",
        title: t("servicePageActivation.trackship.alerts.alreadyDisabled.title"),
        text: t("servicePageActivation.trackship.alerts.alreadyDisabled.text"),
      });
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour les données (désactivation)
      const updatedData = {
        ...data,
        nametrack: "",
        buttontrack: false,
        trackshipactive: false
      };

      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t("servicePageActivation.trackship.alerts.disabledSuccess.title"),
        text: t("servicePageActivation.trackship.alerts.disabledSuccess.text"),
      });

      // Mettre à jour l'état local si nécessaire
      setData(updatedData);
    } catch (error) {
      setLoading(false);

      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.trackship.alerts.disabledError.title"),
        text: t("servicePageActivation.trackship.alerts.disabledError.text"),
      });

      console.error("Error disabling TrackShip:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.trackship.alerts.paidFeature.title"),
      t("servicePageActivation.trackship.alerts.paidFeature.text"),
      true,
      t("servicePageActivation.trackship.alerts.paidFeature.button")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // TrackShip benefits
  const trackshipBenefits = [
    {
      title: t("servicePageActivation.trackship.benefits.list.0.title"),
      description: t("servicePageActivation.trackship.benefits.list.0.description"),
      icon: <MapPin className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.trackship.benefits.list.1.title"),
      description: t("servicePageActivation.trackship.benefits.list.1.description"),
      icon: <Package className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.trackship.benefits.list.2.title"),
      description: t("servicePageActivation.trackship.benefits.list.2.description"),
      icon: <BarChart4 className="text-green-500" size={20} />,
    },
  ];

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#2a2a2a]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3 dark:!text-[#b47ed6]">
              {t("servicePageActivation.trackship.lockedTitle")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto dark:!text-gray-400">
              {t("servicePageActivation.trackship.lockedDescription")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.trackship.buySubscription")}
            </button>
          </div>
        </div>
      </div>

    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center dark:!text-[#b47ed6]">
            <Truck className="ml-2" size={20} />
            {t("servicePageActivation.trackship.title")}
          </h3>
          <p className="text-gray-600 mb-4 dark:!text-gray-400">
            {t("servicePageActivation.trackship.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg border border-blue-200 p-4 flex mb-6 dark:!bg-[#1e293b] dark:!border-[#334155]">
            <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
            <div>
              <p className="font-medium text-blue-800 mb-1 dark:!text-blue-400">
                {t("servicePageActivation.trackship.about.title")}
              </p>
              <p className="text-blue-700 text-sm dark:!text-blue-300">
                {t("servicePageActivation.trackship.about.text")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <label className="block text-sm font-medium text-[#9e68ba] mb-4 dark:!text-[#b47ed6]">
              {t("servicePageActivation.trackship.toggle.label")}
            </label>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.trackshipactive
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#2e1a3a] dark:!border-purple-500"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#1e293b] dark:!border-gray-600 dark:hover:!bg-[#2c3e50]"
                }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.trackshipactive}
                  onChange={() => { }}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.trackshipactive ? "bg-purple-400" : "dark:!bg-gray-500"
                    }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.trackshipactive ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                      }`}
                  />
                </label>
              </div>
              <div>
                <p className="font-medium dark:!text-white">
                  {data.trackshipactive
                    ? t("servicePageActivation.trackship.toggle.activeTitle")
                    : t("servicePageActivation.trackship.toggle.inactiveTitle")}
                </p>
                <p className="text-sm text-gray-500 dark:!text-gray-400">
                  {data.trackshipactive
                    ? t("servicePageActivation.trackship.toggle.activeDescription")
                    : t("servicePageActivation.trackship.toggle.inactiveDescription")}
                </p>
              </div>
            </div>
          </div>

          {/* Button Configuration - Only shown when feature is enabled */}
          {data.trackshipactive && (
            <div className="p-5 border border-gray-200 rounded-lg bg-gray-50 dark:!bg-[#1e293b] dark:!border-gray-600">
              <h4 className="font-medium text-[#9e68ba] mb-4 flex items-center dark:!text-[#b47ed6]">
                <MousePointer className="ml-2" size={18} />
                {t("servicePageActivation.trackship.button.sectionTitle")}
              </h4>

              <div className="space-y-4">
                {/* Button Text Input */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                    {t("servicePageActivation.trackship.button.label")}
                  </label>
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors dark:!bg-[#2c3e50] dark:!border-gray-500 dark:!text-white"
                    placeholder={t("servicePageActivation.trackship.button.placeholder")}
                    value={data.nametrack || ""}
                    onChange={(e) => setData({ ...data, nametrack: e.target.value })}
                  />
                </div>

                {/* Show Button Toggle */}
                <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200 dark:!bg-[#1e293b] dark:!border-gray-600">
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:!text-gray-300">
                      {t("servicePageActivation.trackship.button.showToggleTitle")}
                    </p>
                    <p className="text-xs text-gray-500 dark:!text-gray-400">
                      {t("servicePageActivation.trackship.button.showToggleDescription")}
                    </p>
                  </div>
                  <div className="relative inline-block w-12 align-middle select-none">
                    <input
                      type="checkbox"
                      checked={data.buttontrack}
                      onChange={handleDChange2}
                      className="hidden"
                      id="toggle-button"
                    />
                    <label
                      htmlFor="toggle-button"
                      className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.buttontrack ? "bg-purple-400" : "dark:!bg-gray-500"
                        }`}
                    >
                      <span
                        className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.buttontrack ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                          }`}
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Button Preview */}
              {data.nametrack && (
                <div className="mt-4">
                  <p className="text-sm font-medium text-gray-700 mb-2 dark:!text-gray-300">
                    {t("servicePageActivation.trackship.button.previewLabel")}
                  </p>
                  <div className="p-4 bg-white border border-dashed border-gray-300 rounded-lg flex justify-center dark:!bg-[#2e1a3a] dark:!border-purple-400">
                    <button
                      className="px-4 py-2 bg-[#9b59bf] text-white rounded-lg flex items-center"
                      disabled
                    >
                      <Truck size={16} className="ml-2" />
                      {data.nametrack}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Feature Benefits */}
          {data.trackshipactive && (
            <div className="space-y-4">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#b47ed6]">
                {t("servicePageActivation.trackship.benefits.title")}
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {trackshipBenefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm dark:!bg-[#1e293b] dark:!border-gray-600"
                  >
                    <div className="flex items-center mb-2">
                      {benefit.icon}
                      <h5 className="font-medium text-gray-800 mr-2 text-sm dark:!text-gray-300">
                        {benefit.title}
                      </h5>
                    </div>
                    <p className="text-xs text-gray-600 dark:!text-gray-400">
                      {benefit.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100 dark:!bg-[#3b2f14] dark:!border-[#5c4d1a]">
            <h4 className="font-medium text-yellow-800 mb-2 flex items-center text-lg dark:!text-yellow-400">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.trackship.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
              <li>{t("servicePageActivation.trackship.tips.list.0")}</li>
              <li>{t("servicePageActivation.trackship.tips.list.1")}</li>
              <li>{t("servicePageActivation.trackship.tips.list.2")}</li>
              <li>{t("servicePageActivation.trackship.tips.list.3")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.trackship.buttons.submitting")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("servicePageActivation.trackship.buttons.submit")}
                </>
              )}
            </button>
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDisable}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("servicePageActivation.trackship.buttons.cancel")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
